import { Component, OnInit } from '@angular/core';
import { AlertsService } from '../alerts.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  status = '';
  message = '';

  constructor(private alert: AlertsService) { }

  ngOnInit() {
    this.alert.onAlert.subscribe(req => {
      this.status = req.status;
      this.message = req.message;
      setTimeout(() => {
        this.close();
      }, 5000);
    });

    this.alert.onAlertHide.subscribe(req => {
      this.close();
    });
  }

  close(){
    this.status = '';
  }

}
